document.addEventListener('DOMContentLoaded', function() {
  const STORAGE_KEY = 'super_soya_favoritos';

  // 1. Función para leer la memoria
  function getFavoritos() {
    return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
  }

  // 2. Pintar corazones al cargar la página
  function initCorazones() {
    const favoritos = getFavoritos();
    const botones = document.querySelectorAll('.btn-favorito');
    botones.forEach(boton => {
      const handle = boton.getAttribute('data-product-handle');
      if (favoritos.includes(handle)) {
        boton.classList.add('is-active');
      }
    });
  }

  // 3. Lógica para cuando el cliente le da clic a un corazón
  document.body.addEventListener('click', function(e) {
    const boton = e.target.closest('.btn-favorito');
    if (!boton) return;

    e.preventDefault();
    const handle = boton.getAttribute('data-product-handle');
    if (!handle) return;

    let favoritos = getFavoritos();
    const index = favoritos.indexOf(handle);

    if (index > -1) {
      // Lo quitamos de favoritos
      favoritos.splice(index, 1);
      boton.classList.remove('is-active');
      
      // Si estamos en la página de favoritos, desaparecemos la tarjeta en vivo
      const tarjeta = boton.closest('.columna-favorito');
      if (tarjeta) {
        tarjeta.remove();
        const cont = document.getElementById('contenedor-favoritos');
        if (cont && favoritos.length === 0) {
           cont.innerHTML = '<p class="favoritos-vacios">No tienes productos guardados aún. ¡Explora la tienda!</p>';
        }
      }
    } else {
      // Lo agregamos a favoritos
      favoritos.push(handle);
      boton.classList.add('is-active');
    }
    localStorage.setItem(STORAGE_KEY, JSON.stringify(favoritos));
  });

  // Inicializamos los corazones al cargar la tienda
  initCorazones();

  // ---------------------------------------------------------
  // 4. MAGIA PARA LA PÁGINA DE "MIS FAVORITOS"
  // ---------------------------------------------------------
  if (window.location.pathname.toLowerCase().includes('favoritos')) {
    let contenedor = document.getElementById('contenedor-favoritos');
    
    // Si la plantilla de la página ocultó el contenedor, lo inyectamos a la fuerza
    if (!contenedor) {
      const areaPrincipal = document.querySelector('main') || document.querySelector('#MainContent') || document.body;
      const cajaAuxiliar = document.createElement('div');
      cajaAuxiliar.innerHTML = `
        <div style="text-align: center; margin: 40px 0;"><h1 style="font-family:'Montserrat', sans-serif;">Mis Favoritos</h1></div>
        <div id="contenedor-favoritos" class="grid-productos-favoritos" style="padding: 0 5%; max-width: 1400px; margin: 0 auto;"></div>
      `;
      areaPrincipal.appendChild(cajaAuxiliar);
      contenedor = document.getElementById('contenedor-favoritos');
    }

    if (contenedor) {
      const favoritos = getFavoritos();
      
      // Estilos para la cuadrícula
      const estilo = document.createElement('style');
      estilo.innerHTML = `
        .grid-productos-favoritos { display: grid; grid-template-columns: repeat(auto-fill, minmax(250px, 1fr)); gap: 20px; padding: 20px 0; }
        .favoritos-vacios { text-align: center; color: #6b7280; font-size: 1.1rem; padding: 40px 0; grid-column: 1 / -1; font-family: 'Montserrat', sans-serif;}
      `;
      document.head.appendChild(estilo);

      if (favoritos.length === 0) {
        contenedor.innerHTML = '<p class="favoritos-vacios">No tienes productos guardados aún. ¡Explora la tienda y agrega algunos!</p>';
      } else {
        contenedor.innerHTML = ''; 
        
        // Traemos cada producto guardado
        favoritos.forEach(handle => {
          const wrapper = document.createElement('div');
          wrapper.className = 'columna-favorito';
          wrapper.innerHTML = '<p style="text-align:center; color:#ccc; font-size:12px; margin-top:20px;">Cargando producto...</p>';
          contenedor.appendChild(wrapper);

          fetch('/products/' + handle + '?section_id=tarjeta-favorito')
            .then(response => {
              if(!response.ok) throw new Error("Código HTTP " + response.status);
              return response.text();
            })
            .then(html => {
              // Manejo de respuesta JSON escondida de Shopify
              try {
                const json = JSON.parse(html);
                html = json['tarjeta-favorito'] || html;
              } catch(e) {} 

              const parser = new DOMParser();
              const doc = parser.parseFromString(html, 'text/html');
              const tarjeta = doc.querySelector('.product-item'); 
              
              wrapper.innerHTML = ''; // Borramos texto de carga
              
              if (tarjeta) {
                wrapper.appendChild(tarjeta);
                const botonCorazon = wrapper.querySelector('.btn-favorito');
                if(botonCorazon) botonCorazon.classList.add('is-active');
              } else {
                wrapper.innerHTML = `<div style="border:2px solid red; padding:10px; font-size:12px; color:red; background:#ffeeee;">
                  <b>ALERTA DE CÓDIGO:</b> No se encontró la clase .product-item<br>
                  <b>Producto:</b> ${handle}<br>
                </div>`;
              }
            })
            .catch(err => {
              wrapper.innerHTML = `<div style="border:2px solid red; padding:10px; font-size:12px; color:red; background:#ffeeee;">
                  <b>ERROR DE RED:</b> ${err.message}
                </div>`;
            });
        });
      }
    }
  }
});

// ---------------------------------------------------------
// 5. LÓGICA DEL FILTRO EN BARRA LATERAL (Acceso Directo)
// ---------------------------------------------------------
// Se pone "true" al final para atrapar el clic antes de que Shopify intente recargar la página
document.addEventListener('change', function(e) {
  if (e.target.id === 'filtro-favoritos-sidebar') {
    
    // Bloqueamos la intromisión de la app nativa de filtros
    e.stopPropagation(); 
    
    if (e.target.checked) {
      // Si el cliente marca la casilla, lo llevamos a su página especial
      // Lo desmarcamos rápido por si el cliente usa el botón de "Regresar" del navegador
      setTimeout(() => { e.target.checked = false; }, 500); 
      
      // Redirigimos a la página
      window.location.href = '/pages/favoritos'; 
    }
  }
}, true);